<div class="container px-3 px-md-5 primary-background d-flex justify-content-center">
  <div class="h-100 py-2 pe-5 align-self-center mw-80">
    <h3>
      {{'homepage.direct-channel.bei.title' | translate}}
    </h3>
    <h5>
      {{'homepage.direct-channel.bei.subtitle' | translate}}
      <a (click)="goToBandi()" class="pointer">{{'homepage.direct-channel.bei.open' | translate}}</a>
    </h5>
  </div>
  <div class="py-2 generic-empty w-20">
  </div>
</div>
